import type { Client, ClientStatus } from '@frontend/api-types';
import { identifyGrowthBook } from '@frontend/react';
import { identifyCio } from './cio';
import { identifySegment } from './segment';
import { identifySentry } from './sentry';

export const identifyClient = async (client: Client, env: EnvType, clientStatus?: ClientStatus) => {
  if (!client) return;

  identifySegment({ client, clientStatus, env });
  identifyCio({ client, env });
  identifySentry({ email: client.email, env, id: client.id });
  await identifyGrowthBook({ clientId: client.id });
};
